"use client";

import { AboutDisplay } from "./AboutDisplay";

export function AboutSection() {
  return (
    <div>
      <AboutDisplay />
    </div>
  );
}
